angular.module('dnecom')
    .controller('StoreGeneralMobileSettingsController', ["$scope", "StoreUtils", function ($scope, StoreUtils) {
        if (StoreUtils.getMobileFieldValue($scope.store, 'general', 'mobileDetect') == undefined) {
            StoreUtils.setMobileFieldValue($scope.store, 'general', 'mobileDetect', '1');
            $scope.$parent.originalStore = angular.copy($scope.store);
        }
    }]);
